import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SidebarPayment from "./SidebarPayment";
import AllTransactions from "./AllTransactions";
import DriverLedger from "./DriverLedger";
import PaymentEntry from "./PaymentEntry";
import AddDiscount from "./AddDiscount";
import UpdateCharges from "./UpdateCharges";
import PaymentRefund from "./PaymentRefund";
import PaymentHeadsSettlement from "./PaymentHeadsSettlement";
import "../Css/PaymentLedger1.css";
import Header from "../Header";
import Loader from "../Loader";
import {
  APL_LINK,
  get_drives_data_payment,
  server_post_data,
  get_driver_lager_data,
} from "../../ServiceConnection/serviceconnection";
import { goBack, handleError } from "../../CommonJquery/CommonJquery";
import DriverDayWise from "./DriverDayWise";
import AdjustmentLogs from "./AdjustmentLogs";
const PaymentModule = () => {
  const location = useLocation();
  const activetab = location.state?.activeTab;
  const [activeSection, setActiveSection] = useState(
    activetab || "all-transactions"
  );
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [paymentInfoModalOpen, setPaymentInfoModalOpen] = useState(false);
  const [discountInfoModalOpen, setDiscountInfoModalOpen] = useState(false);
  const [refundConfirmModalOpen, setRefundConfirmModalOpen] = useState(false);
  const [paymentHeadsSettlement, setPaymentHeadsSettlement] = useState(false);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [driverData, setDriverData] = useState([]);
  const [imageLink, setImageLink] = useState("");
  const [dateRangeType, setDateRangeType] = useState("7");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [ledgerData, setLedgerData] = useState([]);
  const [ledgerDataFilter, setLedgerDataFilter] = useState([]);
  const [selectedDriverId, setSelectedDriverId] = useState(0);
  const [selectedDriverBookingId, setSelectedDriverBookingId] = useState(0);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const showSection = (sectionId) => {
    setActiveSection(sectionId);
    setIsMenuOpen(false);
  };

  useEffect(() => {
    master_data_get_drivers();
  }, []);

  const master_data_get_drivers = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    await server_post_data(get_drives_data_payment, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setDriverData(Response.data.message.driver_data);
          console.log(Response.data.message);
          setImageLink(APL_LINK + Response.data.message.image_link);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  let flag = 0;
  useEffect(() => {
    flag = 2;
    master_data_get(
      startDate,
      endDate,
      flag,
      7,
      selectedDriverId,
      selectedDriverBookingId
    );
  }, []);

  const master_data_get = async (
    start_date,
    end_date,
    flag,
    select_type,
    selected_driver,
    selected_driver_booking
  ) => {
    console.log("selected_driver_booking", selected_driver_booking);
    //console.log("flag", flag);
    const current_date = new Date(); // Always available

    if (flag == 2) {
      if (select_type == 7) {
        // Last 7 days
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(current_date.getDate() - 7);

        start_date = formatDate(sevenDaysAgo);
        end_date = formatDate(current_date);
      } else if (select_type == 30) {
        // Last 30 days
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(current_date.getDate() - 30);

        start_date = formatDate(thirtyDaysAgo);
        end_date = formatDate(current_date);
      } else if (select_type == 90) {
        // Last 90 days
        const ninetyDaysAgo = new Date();
        ninetyDaysAgo.setDate(current_date.getDate() - 90);

        start_date = formatDate(ninetyDaysAgo);
        end_date = formatDate(current_date);
      } else if (select_type == "custom") {
        // Custom date range
        start_date = formatDate(new Date(startDate));
        end_date = formatDate(new Date(endDate));
      }
    }

    // Format date function (YYYY-MM-DD)
    function formatDate(dateObj) {
      const year = dateObj.getFullYear();
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
      const day = dateObj.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    }

    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("user_id", selected_driver);
    // fd.append("booking_id", selected_driver_booking);
    await server_post_data(get_driver_lager_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          console.log(Response.data.message);
          setLedgerData(Response.data.message);
          setLedgerDataFilter(Response.data.message.transaction_data);
          setImageLink(APL_LINK + Response.data.message.image_link);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  return (
    <>
      {" "}
      {showLoaderAdmin && <Loader />}
      <Header />
      {/* <div className="pageCntn_head">
        <div className="pageNameDiv">
          <p>Account Ledger</p>
          <img src={GreyArrow} alt="Rapid Car Leasing" />
        </div>
        <Button
          onClick={goBack}
          startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
          className="Back_bttn_page"
        >
          Back
        </Button>
      </div> */}
      <div className="accounting-container">
        <div className="accounting-flex-container">
          {/* Sidebar Component */}
          <SidebarPayment
            activeSection={activeSection}
            showSection={showSection}
            isMenuOpen={isMenuOpen}
            setIsMenuOpen={setIsMenuOpen}
          />

          {/* Main Content */}
          <main className="accounting-main-content">
            <a href="#main-content" className="accounting-skip-link">
              Skip to main content
            </a>

            <div id="main-content" className="accounting-content-container">
              {/* All Transactions Section */}
              <AllTransactions
                activeSection={activeSection}
                master_data_getDriverData={master_data_get_drivers}
                master_data_get={master_data_get}
                driverData={driverData}
                ledgerData={ledgerData}
                ledgerDataFilter={ledgerDataFilter}
                imageLink={driverData}
                setSelectedDriverId={setSelectedDriverId}
                selectedDriverId={selectedDriverId}
                setSelectedDriverBookingId={setSelectedDriverBookingId}
                selectedDriverBookingId={selectedDriverBookingId}
                selectedDriver={selectedDriver}
                setSelectedDriver={setSelectedDriver}
                setStartDate={setStartDate}
                startDate={startDate}
                setEndDate={setEndDate}
                endDate={endDate}
                dateRangeType={dateRangeType}
                setDateRangeType={setDateRangeType}
                flag={flag}
              />
              {/* <AdjustmentLogs activeSection={activeSection} /> */}

              {/* Driver Ledger Section */}
              <DriverLedger
                driverData={driverData}
                activeSection={activeSection}
                imageLink={imageLink}
              />

              <DriverDayWise
                driverData={driverData}
                activeSection={activeSection}
                imageLink={imageLink}
              />

              {/* Payment Entry Section */}
              <PaymentEntry
                activeSection={activeSection}
                paymentInfoModalOpen={paymentInfoModalOpen}
                setPaymentInfoModalOpen={setPaymentInfoModalOpen}
                driverData={driverData}
                master_data_getDriverData={master_data_get_drivers}
                master_data_get={master_data_get}
                selectedDriverId={selectedDriverId}
                selectedDriverBookingId={selectedDriverBookingId}
                startDateAll={startDate}
                endDateAll={endDate}
                flag={2}
                dateRangeType={dateRangeType}
              />

              {/* Add Discount Section */}
              <AddDiscount
                driverData={driverData}
                imageLink={imageLink}
                activeSection={activeSection}
                discountInfoModalOpen={discountInfoModalOpen}
                setDiscountInfoModalOpen={setDiscountInfoModalOpen}
                master_data_getDriverData={master_data_get_drivers}
                master_data_get={master_data_get}
                selectedDriverId={selectedDriverId}
                selectedDriverBookingId={selectedDriverBookingId}
                startDateAll={startDate}
                endDateAll={endDate}
                flag={2}
                dateRangeType={dateRangeType}
              />

              {/* Update Charges Section */}
              <UpdateCharges
                driverData={driverData}
                activeSection={activeSection}
                master_data_getDriverData={master_data_get_drivers}
                master_data_get={master_data_get}
                selectedDriverId={selectedDriverId}
                selectedDriverBookingId={selectedDriverBookingId}
                startDateAll={startDate}
                endDateAll={endDate}
                flag={2}
                dateRangeType={dateRangeType}
              />

              {/* Payment Refund Section */}
              <PaymentRefund
                driverData={driverData}
                activeSection={activeSection}
                refundConfirmModalOpen={refundConfirmModalOpen}
                setRefundConfirmModalOpen={setRefundConfirmModalOpen}
                master_data_getDriverData={master_data_get_drivers}
                master_data_get={master_data_get}
                selectedDriverId={selectedDriverId}
                selectedDriverBookingId={selectedDriverBookingId}
                startDateAll={startDate}
                endDateAll={endDate}
                flag={2}
                dateRangeType={dateRangeType}
              />

              <PaymentHeadsSettlement
                driverData={driverData}
                activeSection={activeSection}
                paymentHeadsSettlement={paymentHeadsSettlement}
                setPaymentHeadsSettlement={setPaymentHeadsSettlement}
                master_data_getDriverData={master_data_get_drivers}
                master_data_get={master_data_get}
                selectedDriverId={selectedDriverId}
                selectedDriverBookingId={selectedDriverBookingId}
                startDateAll={startDate}
                endDateAll={endDate}
                flag={2}
                dateRangeType={dateRangeType}
              />
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default PaymentModule;
